import * as React from 'react';
const LogContext = React.createContext<any>({});


export const LogProvider = ({ children }) => {
    const [Logs, setLogs] = React.useState([]);

    const [showDrawer, setShowDrawer] = React.useState(false);

    const toggleDrawer = (open) => (event) => {
        if (
            event.type === "keydown" &&
            (event.key === "Tab" || event.key === "Shift")
        ) {
            return;
        }
        setShowDrawer(open);
    };

    const UpdateLogs = React.useCallback((log) => {
        setLogs(log);
    }, []);


    return (
        <LogContext.Provider value={{ Logs, UpdateLogs, showDrawer, toggleDrawer }}>
            {children}
        </LogContext.Provider>
    )
}
const useLogProvider = () => {
    return React.useContext(LogContext);
}

export default useLogProvider;